/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Create_TitleInputs */

const cs_projects_create_title = /** @type {(inputs: Projects_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový developerský projekt`)
};

const en_projects_create_title = /** @type {(inputs: Projects_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New developer project`)
};

/**
* | output |
* | --- |
* | "New developer project" |
*
* @param {Projects_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_create_title = /** @type {((inputs?: Projects_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_create_title(inputs)
	return cs_projects_create_title(inputs)
});